import { useEffect, useState } from "react";
import api from "../../api/axios";
import CategoryCreateModal from "./CategoryCreateModal";

export default function CategoryList({ onEdit }) {
  const [categories, setCategories] = useState([]);
  const [search, setSearch] = useState("");
  const [showModal, setShowModal] = useState(false);

  const fetchCategories = async () => {
    const res = await api.get(`companyblog/admin/categories/?search=${search}`);
    setCategories(res.data);
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  return (
    <>
      <div className="card p-3">
        <div className="d-flex justify-content-between mb-3">
          <div>
            <input
              placeholder="Category Name"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <button onClick={fetchCategories}>Search</button>
          </div>

          <button
            className="btn btn-info"
            onClick={() => setShowModal(true)}
          >
            + New Category
          </button>
        </div>

        <table className="table table-bordered">
          <thead>
            <tr>
              <th>S.No.</th>
              <th>Name</th>
              <th>Parent Category</th>
              <th>Description</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {categories.map((cat, index) => (
              <tr key={cat.id}>
                <td>{index + 1}</td>
                <td>{cat.name}</td>
                <td>{cat.parent || "N/A"}</td>
                <td>{cat.description}</td>
                <td>
                  {cat.is_active ? (
                    <span className="badge bg-success">Active</span>
                  ) : (
                    <span className="badge bg-danger">Inactive</span>
                  )}
                </td>
                <td>
                  <button className="btn btn-outline-primary btn-sm" onClick={async () => {await api.put(`companyblog/admin/categories/${cat.id}/update/`,
                  { is_active: !cat.is_active }
                      );
                      fetchCategories();
                    }}
                  >
                    {cat.is_active ? "Deactivate" : "Activate"}
                  </button>
                  <button
                    className="btn btn-outline-danger btn-sm ms-2"
                    onClick={async () => {
                      await api.delete(
                        `companyblog/admin/categories/${cat.id}/delete/`
                      );
                      fetchCategories();
                    }}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {showModal && (
        <CategoryCreateModal
          onClose={() => setShowModal(false)}
          onSuccess={fetchCategories}
        />
      )}
    </>
  );
}
